import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import pageLayout from 'HOC/pageLayout';
import PagesModule from 'modules/pages';
import PageTitle from 'components/PageTitle';


const MDLive = props => {
  const { isAuth, isFetching, isFetched, getPageData, data } = props;
  const content = data?.content;
  const seo = data?.seo;
  const title = data?.content?.title;

  const getInfo = () => {
    getPageData('mdlive');
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <>
      {
        seo &&
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      }
      <div className="page-body">
        <PageTitle align="center">{title}</PageTitle>

        <div className="content-container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-8 offset-lg-2">
                <div
                  className="content-block"
                  dangerouslySetInnerHTML={{
                    __html: content?.data
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default compose(
  pageLayout(),
  connect(
    (state) => {
      return {
        isAuth: state.auth.isAuth,
        data: state.pages.mdlive,
        isFetching: state.pages.isFetching,
      }
    },
    {
      getPageData: PagesModule.fetch,
    }
  ),
)(MDLive);